
seedWebApp.controller('EditPermissionsController', ['$scope', 'role', '$uibModalInstance', 'UserRoleService', 'TranslationService', function ($scope, role, $uibModalInstance, UserRoleService, TranslationService) {

    $scope.listItem = role;
    $scope.translation = TranslationService.getActiveTranslation();
    $scope.loading = true;

    UserRoleService.get({ id: role.UserRoleID }, function (response) {
        $scope.loading = false;
        $scope.error = false;
        $scope.listItem = response;
        $scope.listItem.Modules.map(function (m) {
            if (m.Name == 'MODULE_HOME') {
                m.Disabled = true;
                m.AllowViewExec = true;
            }
        });
    }, function errorFunc(errorDescription) {
        $scope.listItem = [];
        $scope.error = true;
        $scope.errorDescription = errorDescription;
    });


    $scope.savePermission = function () {
        $uibModalInstance.close($scope.listItem);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.userTypes = [
        { Key: 'NORMAL', Value: $scope.translation.Normal },
        { Key: 'AGENT', Value: 'Agente' }
    ];

}]);
